<script setup>
import { format } from '@formkit/tempo'

const props = defineProps({
	event: {
		type: Object,
		required: true,
	},
	to: {
		type: Object,
		required: false,
	},
	accent: {
		type: String,
		required: false,
	},
})
</script>

<template>
	<router-link :to="to" class="group relative flex flex-col overflow-hidden rounded-md bg-logi-grey-500 transition-colors duration-300 hover:bg-logi-grey-400" v-if="to">
		<div class="aspect-video overflow-hidden">
			<img class="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105" :src="event.poster" :alt="event.name" />
		</div>
		<div class="flex grow flex-col gap-4 p-4">
			<div class="text-sm text-logi-blue-500" :style="`color: ${accent ?? '#00AEEF'};`" v-if="event.game">{{ event.game.name }}</div>
			<h6 class="transition-colors duration-300 group-hover:text-logi-blue-500">{{ event.name }}</h6>
			<div class="text-sm text-white/70">
				<i class="far fa-calendar mr-1" />
				{{ format(event.start_at, 'MMM D, YYYY') }} - {{ format(event.finish_at, 'MMM D, YYYY') }}
			</div>
		</div>
		<div class="flex border-t border-white/10">
			<div class="flex grow items-center justify-center gap-4 border-white/10 p-4 text-white/70 [&:not(:last-child)]:border-r" v-if="event.prize_formatted">
				<div class="flex h-5 w-5 items-center justify-center">
					<i :class="event.prize_pool_icon ? event.prize_pool_icon : 'fa-solid fa-sack-dollar'" />
				</div>
				<div class="mt-1 flex flex-col justify-center gap-0.5">
					<div class="text-sm leading-none">{{ event.prize_formatted }}</div>
					<div class="text-xs leading-none text-white/30" v-if="event.prize_pool_subtext">{{ event.prize_pool_subtext }}</div>
				</div>
			</div>
			<div class="flex grow items-center justify-center gap-2 border-white/10 p-5 text-white/70 [&:not(:last-child)]:border-r" v-if="event.genre">
				<div class="flex h-5 w-5 items-center justify-center">
					<i :class="event.genre.icon" />
				</div>
				<p class="mt-1 text-sm">{{ event.genre.name }}</p>
			</div>
		</div>
	</router-link>
	<div class="relative overflow-hidden rounded-md bg-logi-grey-500" v-else>
		<img :src="event.poster" :alt="event.name" class="aspect-video object-cover" />
		<div class="flex flex-col gap-4 p-4">
			<div class="text-sm text-logi-blue-500" :style="`color: ${accent ?? '#00AEEF'}; filter: brightness(${accent ? 1.2 : 1});`" v-if="event.game">{{ event.game.name }}</div>
			<h6>{{ event.name }}</h6>
			<div class="text-sm text-white/70">
				<i class="far fa-calendar-days mr-1" />
				{{ format(event.start_at, 'MMM D, YYYY') }} - {{ format(event.finish_at, 'MMM D, YYYY') }}
			</div>
		</div>
		<div class="flex border-t border-white/10">
			<div class="flex grow items-center justify-center gap-2 border-white/10 p-5 text-white/70 [&:not(:last-child)]:border-r" v-if="event.prize_formatted">
				<div class="flex h-5 w-5 items-center justify-center">
					<i :class="event.prize_pool_icon ? event.prize_pool_icon : 'fa-solid fa-sack-dollar'" />
				</div>
				<div class="mt-1 flex flex-col justify-center">
					<div class="text-sm">{{ event.prize_formatted }}</div>
					<div class="text-xs text-white/30" v-if="event.prize_pool_subtext">{{ event.prize_pool_subtext }}</div>
				</div>
			</div>
			<div class="flex grow items-center justify-center gap-2 border-white/10 p-5 text-white/70 [&:not(:last-child)]:border-r" v-if="event.genre">
				<div class="flex h-5 w-5 items-center justify-center">
					<i :class="event.genre.icon" />
				</div>
				<p class="mt-1 text-sm">{{ event.genre.name }}</p>
			</div>
		</div>
	</div>
</template>
